<template>
  <div class="app-footer embeddable-footer p-2 text-nowrap" >
    <a href="https://www.icij.org" target="_blank" class="text-white embeddable-footer__brand">
      <brand :size="40" no-border class="mr-2" color="white" />
    </a>
    <div class="embeddable-footer__lead small text-truncate">
      <!-- @slot Main slot to redefine lead text display -->
      <slot>
        
        <a href="https://www.icij.org/investigations/pandora-papers/power-players" target="_blank" class="text-white">
          <span>Pandora Papers - Power Players</span>
        </a>
      </slot>
    </div>

  </div>
</template>

<script>
import utils from '@/mixins/utils'

export default {
  name: 'AppFooterEmbed',
  mixins: [utils],
  props: {
    title: {
      default: ``,
      type: String
    }
  },
  data () {
    return {
      enableFooter: true,
      sharingOptionsValues: Object,
      showShareOptions: false
    }
  }
}
</script>

<style lang="scss" scoped>
  
  @import '@/variables.scss';

  .embeddable-footer {
    padding-top: 250px;
    display: flex;
    flex-direction: row;
    align-items: center;
    z-index: $zindex-sticky;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background: var(--app-color-black);
    color: white;
    a {
      text-decoration: none;
    }

    // Magic technique to have a minimum font-size (10px-ish)
    font-size: calc(10px + 1.5vh);
    @media screen and (min-height: 800px) {
      font-size: 1rem;
    }
    &__brand {
      margin-right: $spacer;
      border-right: 2px solid white;
      font-family: $headings-font-family;
      font-size: 1.1em;
    }
    &__lead {
      flex-grow: 1;
      min-width: 0;
      font-size: 0.9em;
      font-family: var(--headings-type-writer);
      font-size: 18px;
      font-weight: 900;
      letter-spacing: -1.5px;
    }
    &__share-btn {
      border:1px solid transparent;
      height: 2.5em;
      line-height: 2.5em;
      width: 2.5em;
      font-size: 80%;
      text-align: center;
      border-radius: 50%;
      &.active {
        border-color: white;
      }
      &:hover {
        background: rgba(white, .1);
      }
    }
  }
</style>